import React, { useState, useEffect } from "react";
import Pagination from "react-responsive-pagination";
import { toast } from "react-toastify";
import axios from "utils/axios";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Rating,
} from "@mui/material";
import { scrollToTop, getDate } from "utils/utils";
import VisibilityIcon from "@mui/icons-material/Visibility";

const Reviews = () => {
  const [formData, setFormData] = useState<Array<any>>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [showCount, setShowCount] = useState<number>(10);
  const [resources, setResources] = useState<Array<any>>([]);
  const [shownData, setShownData] = useState<any>({});

  const loadPage = async () => {
    try {
      const response = await axios.get(
        `/api/review/read/${showCount}/${currentPage}`
      );
      setTotalPages(Math.ceil(response.data.count / showCount));
      setFormData(response.data.rows);
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getResource();
  }, []);

  useEffect(() => {
    scrollToTop();
    loadPage();
  }, [currentPage, showCount]); //eslint-disable-line

  const getResource = async () => {
    const result = await axios.get("/api/resource/getAllResourceName");
    setResources(result.data);
  };

  const handlePageChange = (e: number) => {
    setCurrentPage(e);
  };
  const handleCountChange = (e: number) => {
    if (totalPages === 1 && e > showCount) {
      toast.warning(
        "All results displayed! You can see all the resources currently."
      );
      return;
    }
    setCurrentPage(1);
    setShowCount(e);
  };

  const handleRead = (review: any) => {
    setShownData(review);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="main-text text-right sm:text-center">
        <span
          className={`cursor-pointer ${
            showCount === 10 ? "text-button font-extrabold" : ""
          }`}
          onClick={() => handleCountChange(10)}
        >
          10
        </span>
        {" | "}
        <span
          className={`cursor-pointer ${
            showCount === 25 ? "text-button font-extrabold" : ""
          }`}
          onClick={() => handleCountChange(25)}
        >
          25
        </span>
        {" | "}
        <span
          className={`cursor-pointer ${
            showCount === 100 ? "text-button font-extrabold" : ""
          }`}
          onClick={() => handleCountChange(100)}
        >
          100
        </span>
      </div>
      <div className="grid gap-[8px]">
        {formData?.map((review, index) => (
          <div
            className="px-[12px] py-[8px] flex sm:flex-col items-center justify-between sm:items-start bg-gray main-text border-solid border-[1.5px] border-[#bdbdbd] rounded-sm shadow-md hover:shadow-none cursor-default"
            key={index}
          >
            <span className="flex gap-[16px] items-center">
              {resources.map((resource) => {
                if (resource.id === review.resourceId) return resource.name;
                return "";
              })}
              [{review.organization}]<br />
              {getDate(review.date)}
            </span>
            <div className="flex sm:ml-auto sm:mt-[20px]">
              <div
                onClick={() => handleRead(review)}
                className="cursor-pointer"
              >
                <VisibilityIcon color="primary" />
              </div>
            </div>
          </div>
        ))}
        <Pagination
          total={totalPages}
          current={currentPage}
          onPageChange={(page) => handlePageChange(page)}
          maxWidth={300}
        />
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Review Detail</DialogTitle>
          {shownData !== "" && (
            <DialogContent>
              <p className="text-lg !m-0 font-opensans font-light leading-[28px] tracking-[0.6px] mb-4 w-[540px] sm:w-full">
                {shownData.username}
              </p>
              <div className="my-1">
                <span className="mx-1">{getDate(shownData?.date)}</span>
                <span>
                  [
                  {resources.map((resource) => {
                    if (resource.id === shownData.resourceId)
                      return resource.name;
                    return "";
                  })}
                  ]
                </span>
              </div>
              <p>
                <Rating value={shownData.rating} readOnly />
              </p>
              <p className="mx-1">{shownData.content}</p>
            </DialogContent>
          )}
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Reviews;
